import { Dispatch, SetStateAction, useCallback } from 'react'
import { filterBreadsByCategory, filterBreadsByKeyword } from 'lib/filter'
import { BreadType } from 'types/bread'
import { CategoryType } from 'types/category'

const useSearchBreads = (
  breads: BreadType[],
  categories: CategoryType[],
  categoryName: string,
  keyword: string,
  setCategoryName: Dispatch<SetStateAction<string>>,
  setBreadList: Dispatch<SetStateAction<BreadType[]>>
): (() => void) => {
  return useCallback(() => {
    // カテゴリでフィルターした後にキーワードでフィルタリング
    const filteredBreadsByCategory = filterBreadsByCategory(categoryName, categories, breads)
    const filteredBreadsByKeyword = filterBreadsByKeyword(keyword, filteredBreadsByCategory)
    setBreadList([...filteredBreadsByKeyword])
  }, [breads, categories, categoryName, keyword, setCategoryName, setBreadList])
}

export default useSearchBreads
